/**
 * Compare function reproducing the default `Array.prototype.sort` ordering
 * (UTF-16 code units for strings, numeric for numbers), for the places where
 * that exact ordering is expected.
 */
export const compareCodeUnits = <T extends string | number>(
  a: T,
  b: T,
): number => {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
